import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=5246b9ee"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=5246b9ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports